import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';

export const getAuditLogs = (data: any): Promise<any> =>
  api()
    .post(`/portal-api/log/getAuditLogs`, data, {
      signal: (window as any).myAbortController.signal,
    })
    .then((response) => get(response, 'data'))
    .catch((error) => false);
